import { lazy } from "react";
import { Navigate } from "react-router-dom";
import WithSuspense from "../../components/Loaders/WithSuspense";
import { AppRoute } from "../types";
import { PMO_SETTINGS_ROLES, PRIVATE_PATHS } from "../constants";
import TaskDetailShell from "../../pages/ProjectManagement/Projects/TaskDetailShell";
import { PmoRedirect } from "../../components/common/PmoRedirect";
import ConvertToScrum from "pages/ProjectManagement/Settings/Tabs/ConvertToScrum";

const { PMO } = PRIVATE_PATHS;

const Projects = WithSuspense(lazy(() => import("../../pages/ProjectManagement/Projects/AllProjects")));
const TeamInsights = WithSuspense(lazy(() => import("../../pages/ProjectManagement/TeamInsights/TeamInsights")));
const TeamInsightsMemberDetails = WithSuspense(lazy(() => import("../../pages/ProjectManagement/TeamInsights/TeamInsightsMemberDetails")));
const CreateProject = WithSuspense(lazy(() => import("../../pages/ProjectManagement/Projects/CreateProject")));
const ProjectView = WithSuspense(lazy(() => import("../../pages/ProjectManagement/Projects/ProjectView")));
const ReportsAnalytics = WithSuspense(lazy(() => import("../../pages/ProjectManagement/Projects/ReportsAnalytics")));
const GlobalSearchPage = WithSuspense(lazy(() => import("../../pages/GlobalSearch/GlobalSearch")));
const MyTasks = WithSuspense(lazy(() => import("../../pages/ProjectManagement/MyTasks")));

const SettingsLayout = WithSuspense(lazy(() => import("../../pages/ProjectManagement/Settings/SettingsLayout")));
const WorkSchedule = WithSuspense(lazy(() => import("../../pages/ProjectManagement/Settings/Tabs/WorkSchedule")));
const HolidayCalendars = WithSuspense(lazy(() => import("../../pages/ProjectManagement/Settings/Tabs/HolidayCalendars")));
const MemberAvailability = WithSuspense(lazy(() => import("../../pages/ProjectManagement/Settings/Tabs/MemberAvailability")));
const ComingSoon = WithSuspense(lazy(() => import("../../pages/ProjectManagement/Settings/Tabs/ComingSoon")));

const PMO_ROLES = ["PMO_ADMIN", "PMO_MANAGER", "PMO_USER", "ORG_OWNER", "ORG_ADMIN", "EMPLOYEE"];
const PMO_ADMIN_ROLES = ["PMO_ADMIN", "PMO_MANAGER", "ORG_OWNER", "ORG_ADMIN"];
const PMO_TEAM_INSIGHTS_ROLES =["PMO_ADMIN", "PMO_MANAGER", "ORG_OWNER", "ORG_ADMIN"];


export const PMO_MODULE_ROUTES: AppRoute[] = [
  { path: PMO.GLOBAL_SEARCH,  element: <GlobalSearchPage />, roles: PMO_ROLES },
  { path: PMO.PROJECTS,       element: <Projects />,         roles: PMO_ROLES },
  { path: PMO.CREATE_PROJECT, element: <CreateProject />,    roles: PMO_ADMIN_ROLES },
  { path: PMO.EDIT_PROJECT,   element: <CreateProject />,    roles: PMO_ADMIN_ROLES },
  { path: PMO.REPORTS_ANALYTICS, element: <ReportsAnalytics />, roles: PMO_ROLES },
  { path: PMO.MY_TASKS,       element: <MyTasks />,          roles: PMO_ROLES },
  { path: PMO.TEAM_INSIGHTS,                element: <TeamInsights />,               roles: PMO_TEAM_INSIGHTS_ROLES },
  { path: PMO.TEAM_INSIGHTS_MEMBER_DETAILS, element: <TeamInsightsMemberDetails />,  roles: PMO_TEAM_INSIGHTS_ROLES },
  {
    path: PMO.SETTINGS.MAIN,
    element: <SettingsLayout />,
    roles: PMO_SETTINGS_ROLES,
    children: [
      // Settings has no landing page of its own. Holiday Calendars first:
      // member availability is set up against them.
      { index: true, element: <Navigate to="holiday-calendars" replace /> },
      {
        path: PMO.SETTINGS.TAGS,
        element: <ComingSoon title="Tags" description="Manage the tags used across projects and work items." />,
      },
      { path: PMO.SETTINGS.CONVERT_TO_SCRUM, element: <ConvertToScrum /> },
      { path: PMO.SETTINGS.MEMBER_AVAILABILITY, element: <MemberAvailability /> },
      { path: PMO.SETTINGS.WORK_SCHEDULE, element: <WorkSchedule /> },
      { path: PMO.SETTINGS.HOLIDAY_CALENDARS, element: <HolidayCalendars /> },
    ],
  },
  { path: PMO.VIEW_PROJECT,   element: <ProjectView />,      roles: PMO_ROLES },
  { path: PMO.BACKLOG,        element: <ProjectView />,      roles: PMO_ROLES },
  { path: PMO.BOARD,          element: <ProjectView />,      roles: PMO_ROLES },
  { path: PMO.ACTIVE_SPRINT,  element: <ProjectView />,      roles: PMO_ROLES },
  { path: PMO.SPRINT_HISTORY, element: <ProjectView />,      roles: PMO_ROLES },
  { path: PMO.EPICS,          element: <ProjectView />,      roles: PMO_ROLES },
  { path: PMO.EPIC_DETAILS,   element: <ProjectView />,      roles: PMO_ROLES },
  { path: PMO.CREATE_TASK,    element: <TaskDetailShell />,  roles: PMO_ROLES },
  { path: PMO.TASK_DETAILS,   element: <TaskDetailShell />,  roles: PMO_ROLES },
  { path: "/:orgSlug/pmo",    element: <PmoRedirect to="projects" />, roles: PMO_ROLES },
];
